(function () {
  'use strict';

  angular
    .module('dashboard.project.alltime')
    .controller('dashboardProjectAlltimeCtrl', dashboardProjectAlltimeCtrl);

  dashboardProjectAlltimeCtrl.$inject = [
    'DashboardProjectAlltime',
    '$translate',
    '$rootScope',
    '$scope',
    'datamatic',
  ];

  function dashboardProjectAlltimeCtrl(
    DashboardProjectAlltime,
    $translate,
    $rootScope,
    $scope,
    datamatic,
  ) {
    var vm = this;

    vm.metric = 'value';
    vm.periodType = '2';
    vm.projectId = -1;
    vm.projects = getProjects();
    vm.noData = true;
    vm.chartData = [];

    var requestInProgress = false;

    var textValue = $translate.instant('reports.page.sales.by.time.income');
    var textCount = $translate.instant('reports.page.sales.by.time.count');
    var textSqm = $translate.instant('reports.page.sales.by.time.sqm');
    var textPeriodWeeks = $translate.instant(
      'reports.page.sales.by.time.weeks',
    );
    var textPeriodMonths = $translate.instant(
      'reports.page.sales.by.time.months',
    );
    $rootScope.$on('$translateChangeSuccess', function () {
      textValue = $translate.instant('reports.page.sales.by.time.income');
      textCount = $translate.instant('reports.page.sales.by.time.count');
      textSqm = $translate.instant('reports.page.sales.by.time.sqm');
      textPeriodWeeks = $translate.instant('reports.page.sales.by.time.weeks');
      textPeriodMonths = $translate.instant(
        'reports.page.sales.by.time.months',
      );
    });

    vm.metricsList = [
      { id: 'value', name: textValue },
      { id: 'count', name: textCount },
      { id: 'sqm', name: textSqm },
    ];

    vm.periodTypes = [
      { id: '1', name: textPeriodWeeks },
      { id: '2', name: textPeriodMonths },
    ];

    function getProjects() {
      DashboardProjectAlltime.getProjects({}).$promise.then(
        function (response) {
          vm.projects = response;
        },
        function (error) {},
      );
    }

    vm.getDataAlltime = function (periodType, projectId) {
      if (!requestInProgress) {
        requestInProgress = true;
        DashboardProjectAlltime.getProjectAlltime({
          period: periodType,
          project: projectId != -1 ? projectId : null,
        }).$promise.then(
          function (response) {
            vm.noData = false;
            requestInProgress = false;
            vm.chartData = response;
            vm.mapForChart(response, vm.metric);
          },
          function (error) {
            vm.noData = true;
            requestInProgress = false;
          },
        );
      }
    };

    vm.mapForChart = function (arr, metric) {
      var dataSales = [];
      if (arr.length) {
        dataSales = arr.map(function (obj) {
          return Object.keys(obj).reduce(function (result, key) {
            if (key === 'period_start') {
              if (vm.periodType === '1') {
                result.push(obj[key].replace(/\s\d+:\d+:\d+/g, ''));
              } else {
                result.push(obj[key].replace(/-\d+\s\d+:\d+:\d+/g, ''));
              }
            }
            switch (metric) {
              case 'value':
                if (key === 'deals_value') {
                  result.push(obj[key] ? obj[key] + '' : '0');
                }
                break;
              case 'count':
                if (key === 'deals') {
                  result.push(obj[key] ? obj[key] + '' : '0');
                }
                break;
              case 'sqm':
                if (key === 'area_sold') {
                  result.push(obj[key] ? obj[key] + '' : '0');
                }
                break;
              default:
                break;
            }

            return result;
          }, []);
        });
      }

      var color = '';
      switch (metric) {
        case 'value':
          color = '#2196f3';
          break;
        case 'count':
          color = '#DD4D79';
          break;
        case 'sqm':
          color = '#BD3B47';
          break;
        default:
          color = '#2196f3';
      }

      var dmTemplate = [
        ['', 'Value'],
        ['', color],
      ];

      $scope.height = 545;
      $scope.width = 900;
      $scope.dataSales = dmTemplate.concat(dataSales);
      $rootScope.$broadcast('chart.update');
    };
  }
})();
